<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="dateRangeText"
          placeholder="DATE RANGE"
          prepend-icon="mdi-calendar"
          readonly
          v-on:click="showDateSelector = !showDateSelector"/>
        <!--        <v-btn @click="getHistoryOrders" block>-->
        <!--          <span>Get</span></v-btn>-->
      </v-col>
    </v-row>
    <v-row v-if="orders.length == 0 && message.length > 0">
      <v-col cols="12">
        {{message}}
      </v-col>
    </v-row>
    <v-list dense v-else-if="orders.length > 0" class="pa-0">
      <v-card class="mb-10" v-for="pendingOrder in orders" :key="pendingOrder.id">
        <v-row class="pa-1 sent-order" v-bind:class="{'confirmed-order': pendingOrder.confirmed == true}" no-gutters align="center" @click="pendingOrder.selected = !pendingOrder.selected">
          <v-col cols="12">
            <div class="h5">#{{pendingOrder.id}} <br><span v-if="pendingOrder.vendor != null">{{pendingOrder.vendor.title}}</span></div>
          </v-col>

          <v-col class="text-left" cols="12">
            <span v-if="pendingOrder.deliveryDate != null && pendingOrder.deliveryDate.length > 0">Delivery requested: <strong>{{pendingOrder.deliveryDate}}</strong></span>
            <br>

            <!--            <v-icon>fas fa-sign-out-alt</v-icon>-->
          </v-col>
          <v-col class="text-left" cols="12">
            <span v-if="pendingOrder.orderSentTime > 0">Submitted on {{timestampToDate(pendingOrder.orderSentTime)}}</span>
            <br>

            <!--            <v-icon>fas fa-sign-out-alt</v-icon>-->
          </v-col>
          <v-col class="text-left" style="font-weight: bold;" cols="12">
            <span v-if="pendingOrder.confirmed == true">
              Confirmed on {{timestampToDate(pendingOrder.confirmedTime)}}
            </span>
          </v-col>
          <v-col cols="12" v-if="pendingOrder.state === 0">
            <span style="color: red; font-weight: bold;">This order was not sent to vendor.</span><br/>
            <button class="btn btn-primary" @click.stop="sendOrder(pendingOrder)">Send order</button>
          </v-col>
        </v-row>
        <template v-if="pendingOrder.selected === true">
        <v-row v-for="order in pendingOrder.list" :key="order.id" no-gutters class="mx-4">
          <v-col>
            <v-row align="start">
              <v-col cols="8">
                <div class="subtitle-2 py-0" v-text="order.title"/>
<!--                <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />-->
              </v-col>
              <v-col cols="4">
                <div class="text-right font-weight-bold caption">X {{order.amount}}</div>
<!--                <div class="text-right font-weight-bold caption">£{{(order.totalPrice / 100).toFixed(2)}}</div>-->
<!--                <div class="text-right font-weight-bold caption">VAT: £{{(order.tax / 100).toFixed(2)}}</div>-->
<!--                <div class="text-right font-weight-bold caption">Total: £{{(order.finalDue / 100).toFixed(2)}}</div>-->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="ma-0"/>
        <v-row>

          <v-col cols="6" class="text-left">
<!--            <button class="btn btn-success" style="margin-left: 10px;" v-on:click="duplicateOrder(pendingOrder)">Duplicate Order</button>-->
          </v-col>
          <v-col cols="6" class="text-right">
            <button class="btn btn-dark" style="margin-right:10px;" v-on:click="pendingOrder.selected = false">Close</button>
          </v-col>
        </v-row>
        <v-divider class="ma-0"/>
        </template>
<!--        <v-row v-if="pendingOrder.notes !== null && pendingOrder.notes.length > 0" no-gutters class="mx-4">-->
<!--          <v-col>-->
<!--            &lt;!&ndash;          <v-list-item-title class="text-left">&ndash;&gt;-->
<!--            &lt;!&ndash;            ORDER MEMO&ndash;&gt;-->
<!--            &lt;!&ndash;          </v-list-item-title>&ndash;&gt;-->
<!--            &lt;!&ndash;            <template v-if="pendingOrder.notes.length > 0">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="text-left caption"  v-for="note in pendingOrder.notes" :key="note.id">{{note.userName}}: {{note.description}}</div>&ndash;&gt;-->
<!--            &lt;!&ndash;            </template>&ndash;&gt;-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--        <bill label="TOTAL PRICE"   :value="pendingOrder.totalPrice"/>-->
<!--        <bill label="VAT"           :value="pendingOrder.tax"/>-->
<!--        <bill label="Due"           :value="pendingOrder.finalDue"/>-->
<!--        <bill label="DC"            :value="pendingOrder.discountAmount" v-if="pendingOrder.discountAmount !== 0"/>-->
<!--        <bill label="DELIVERY DATE" :text="pendingOrder.deliveryDate"/>-->

      </v-card>
    </v-list>
    <v-dialog v-model="showDateSelector">
      <v-date-picker
        v-model="dates"
        range/>
      <v-btn v-on:click="getHistoryOrders">
        <span>SEARCH</span>
      </v-btn>
    </v-dialog>
    <v-dialog v-model="basketDialog">
      <v-card>
        <v-card-title>
          Added to basket
        </v-card-title>
        <v-card-subtitle style="padding-top:20px;">
          {{basketDialogMessage}}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="basketDialog = false">Stay</v-btn>
          <v-btn color="green darken-1" text @click="moveToBasket">Move to Basket</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {millisToDate, showDialog} from "../api/utils";
    import {getOrderList, getVendorOrderList, loadBasket, newChildOrderFromOrder, saveBasket} from "../api/order";
    import EventBus from "../api/event-bus";
import {sendVendorOrder} from "../api/vendor";

    export default {
        name: "VendorOrders",
      data() {
        return {
          orders:[],
          message:'',
          startDate:'',
          toDate:'',
          dates:[],
          showDateSelector:false,

          basketDialog:false,
          basketDialogMessage:'',
        }
      },
      beforeDestroy() {
      },
      created() {
      },
      mounted() {
        this.initialise();
      },
      computed: {
        dateRangeText () {
          return this.dates.join(' ~ ')
        },
      },
      methods: {
        initialise: function() {
          let today = new Date();
          let dateTo = millisToDate(today.getTime());
          today.setDate(today.getDate() - 7);
          let dateFrom = millisToDate(today.getTime());
          this.$data.dates = [dateFrom, dateTo];
          this.getHistoryOrders();
        },
        getHistoryOrders: function() {
          this.showDateSelector = false

          if(this.$data.dates.length == 0) {
            showDialog("Please select date range");
            return;
          }
          EventBus.$emit('showLoading', true);
          this.$data.order = [];
          this.$data.message = '';
          let query = "stateFrom=100&stateTo=100";
          var start = new Date(this.$data.dates[0]);
          start.setHours(0,0,0,0);

          if(this.$data.dates.length == 1) {
            this.$data.dates.push(this.$data.dates[0]);
          }
          var end = new Date(this.$data.dates[1]);
          end.setHours(23,59,59,999);

          query += "&timeFrom=" + start.getTime() + "&timeTo=" + end.getTime();
          let self = this;
          getVendorOrderList(query)
            .then(function(data) {
              EventBus.$emit('showLoading', false);
              if(data.success == true) {
                data.item.sort(function(a, b) {
                  if(a.orderSentTime < b.orderSentTime) {
                    return 1;
                  } else if(a.orderSentTime > b.orderSentTime) {
                    return -1;
                  } else {
                    return 0;
                  }
                })
                self.$data.orders = data.item;
              } else {
                self.$data.message = data.message;
              }
            })
            .catch(function(err) {
              EventBus.$emit('showLoading', false);
            })
        },
        timestampToDate: function (timestamp) {
          let date = new Date(timestamp)

          return date.toLocaleString();
        },
        sendOrder: function(order) {
          let self = this;
          EventBus.$emit('showLoading', true);
          sendVendorOrder(order.id)
            .then(function(data) {
              EventBus.$emit('showLoading', false);
              if(data.success === true) {

                showDialog("Order has been successfully sent");
                self.getHistoryOrders();
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              EventBus.$emit('showLoading', false);
              showDialog("Unknown error", "ERROR");
            })
        },

        checkAvailability: function() {

        },
        duplicateOrder: function(order) {
          if(order.list == undefined || order.list == null || order.list.length == 0) {
            return;
          }

          let basketOrder = loadBasket(order.vendorId)
          console.log(basketOrder);

          // if(basketOrder.vendorId == 0) {
          //   basketOrder.deliveryDate = getDeliveryDay(this.$data.deliveryDates);
          // }

          for(let o = 0 ; o < order.list.length ; o++) {
            let found = false;
            if (basketOrder.list != null && basketOrder.list.length > 0) {
              for (let i = 0; i < basketOrder.list.length; i++) {
                if (basketOrder.list[i].productId == order.list[o].productId && basketOrder.list[i].vendorId == order.vendorId) {
                  basketOrder.list[i].amount += order.list[o].amount;
                  basketOrder.list[i].totalPrice = basketOrder.list[i].price * basketOrder.list[i].amount;
                  basketOrder.list[i].tax = basketOrder.list[i].totalPrice * basketOrder.list[i].taxRate / 10000;
                  basketOrder.list[i].finalDue = basketOrder.list[i].totalPrice + basketOrder.list[i].tax;
                  found = true;
                  break;
                }
              }
            }

            if (found == false) {
              let newOrder = newChildOrderFromOrder(order.list[o], '')


              console.log(newOrder);
              basketOrder.list.push(newOrder)

            }
          }
          let totalPrice = 0;
          let tax = 0;
          for(let i = 0 ; i < basketOrder.list.length ; i++) {
            totalPrice += basketOrder.list[i].totalPrice;
            tax += basketOrder.list[i].tax;
          }

          basketOrder.totalPrice = totalPrice;
          basketOrder.tax = tax;
          basketOrder.finalDue = totalPrice + tax;
          saveBasket(basketOrder, order.vendorId);
          EventBus.$emit('onBasket',1);
          this.$data.basketDialogMessage = "Do you want to move to basket page?"
          this.$data.basketDialog = true;
        },
        moveToBasket: function() {
          this.$data.basketDialog = false;
          this.$router.push('/basket');
        }
      }
    }
</script>

<style scoped>

  .sent-order {
    background-color: #FFC9C9;
  }
  .confirmed-order {
    background-color: #9DE5A9
  }
  .completed-order {
    background-color: #CCD1FA;
  }
</style>



// WEBPACK FOOTER //
// src/components/VendorOrders.vue